// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"faebcdb1e51d31835f81","418":"a12be178b0a9e8475053","661":"9c3dbe6f25abb81eefa8"}[chunkId] + ".bundle.js";
};